import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import styled from 'styled-components'

const StyledPianoInline = styled.div`
  position: relative;

  &:empty {
    display: none;
  }
`

const PianoInline: FunctionComponent = () => (
  <StyledPianoInline className="pianocontainer" />
)

const widget: CookWidget = {
  kind: ['widget', 'inline-piano'],
  component: PianoInline,
}

export default widget
